import {
    List,
    ListItem,
    ListItemButton, ListItemIcon,
    ListItemText
} from "@mui/material";
import {
    CorporateFare,
    Inventory2,
    ShoppingCart,
    Store,
    People,
    LocalPharmacy,
} from "@mui/icons-material";
import React from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {canViewTenantUsers, useUser} from "../providers/user-context";

export const MenuBarComp = ({tenantType}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const {t} = useTranslation();
    const {userRole} = useUser();
    const isActivePath = path => location.pathname === path || (path === "/distributor/users"
        && location.pathname.startsWith("/distributor/users/"));

    const menuItemsPharmacy = [
        {label: t("Products"), path: "/pharmacy/products", icon: <Inventory2/>},
        {label: t("Orders"), path: "/pharmacy/my-orders", icon: <ShoppingCart/>},
        {label: t("Distributors"), path: "/distributors", icon: <Store/>},
        {label: t("Partners"), path: "", icon: <CorporateFare/>}
    ];

    const menuItemsDistributor = [
        {label: t("Products"), path: "/distributor/all-products", icon: <Inventory2/>},
        {label: t("Orders"), path: "/distributor/my-orders", icon: <ShoppingCart/>},
        {label: t("Pharmacies"), path: "/pharmacies", icon: <LocalPharmacy/>},
        {label: t("Partners"), path: "", icon: <CorporateFare/>}
    ];

    const menuItemsSystem = [
        {label: t("Products"), path: "/distributor/all-products", icon: <Inventory2/>},
        {label: t("Partners"), path: "", icon: <CorporateFare/>}
    ];

    if (canViewTenantUsers(tenantType, userRole)) {
        menuItemsDistributor.push({label: t("UserManagement"), path: "/distributor/users", icon: <People/>});
    }

    const menuItems = tenantType === "PHARMACY" ? menuItemsPharmacy : tenantType === "IMPORTER" ? menuItemsDistributor : menuItemsSystem;

    const handleNavigation = (path) => {
        if (path && location.pathname !== path) {
            navigate(path);
        }
    };

    return (
        <List>
            {menuItems.map((item) => (
                <ListItem disablePadding key={item.path}>
                    <ListItemButton
                        onClick={() => handleNavigation(item.path)}
                        aria-current={isActivePath(item.path) ? "page" : undefined}
                        sx={{
                            color: isActivePath(item.path) ? "primary.main" : "inherit",
                            borderRadius: "4px",
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                marginLeft: "-10px",
                                minWidth: 32,
                                color: isActivePath(item.path) ? "primary.main" : "inherit"
                            }}
                        >
                            {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.label}/>
                    </ListItemButton>
                </ListItem>
            ))}
        </List>
    );
};
